/* Invisible GA4 item-list tracking for the CCV collection rows
   (ccv-row-rail / ccv-row-grid / ccv-row-value).

   F13: this IIFE used to be inlined once per row — three copies of the same
   ~2.5 KB on the homepage. It is now one cacheable asset. Each row still emits
   the <script src> tag (sections cannot share Liquid state), so the browser
   fetches it once and the `__ccvTrackInit` guard below keeps the second and
   third evaluations no-ops. The events themselves are byte-for-byte unchanged:
     - view_item_list  when a row scrolls into view (IntersectionObserver, once per row)
     - select_item     when a product card in a row is clicked
*/
(function () {
  if (window.__ccvTrackInit) return; window.__ccvTrackInit = 1;
  function fire(name, params) { try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {} }
  function itemOf(card, root) {
    var it = {
      item_id: card.getAttribute('data-ccv-id'),
      item_name: card.getAttribute('data-ccv-name'),
      item_list_id: root.getAttribute('data-ccv-list'),
      item_list_name: root.getAttribute('data-ccv-list-name')
    };
    var pr = parseFloat(card.getAttribute('data-ccv-price')); if (!isNaN(pr)) it.price = pr;
    var ix = parseInt(card.getAttribute('data-ccv-index'), 10); if (!isNaN(ix)) it.index = ix;
    return it;
  }
  function itemsOf(root) {
    var cards = root.querySelectorAll('.crow__card[data-ccv-id]'), out = [];
    for (var i = 0; i < cards.length; i++) out.push(itemOf(cards[i], root));
    return out;
  }
  function init() {
    var roots = document.querySelectorAll('[data-ccv-list]');
    if (!roots.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var en = entries[i]; if (!en.isIntersecting) continue;
          var root = en.target; if (root.__ccvSeen) continue; root.__ccvSeen = 1; io.unobserve(root);
          fire('view_item_list', {
            item_list_id: root.getAttribute('data-ccv-list'),
            item_list_name: root.getAttribute('data-ccv-list-name'),
            items: itemsOf(root)
          });
        }
      }, { threshold: 0.4 });
      for (var r = 0; r < roots.length; r++) io.observe(roots[r]);
    } else {
      for (var k = 0; k < roots.length; k++) {
        if (roots[k].__ccvSeen) continue; roots[k].__ccvSeen = 1;
        fire('view_item_list', { item_list_id: roots[k].getAttribute('data-ccv-list'), item_list_name: roots[k].getAttribute('data-ccv-list-name'), items: itemsOf(roots[k]) });
      }
    }
    document.addEventListener('click', function (e) {
      var card = e.target.closest && e.target.closest('.crow__card[data-ccv-id]'); if (!card) return;
      var root = card.closest('[data-ccv-list]'); if (!root) return;
      fire('select_item', {
        item_list_id: root.getAttribute('data-ccv-list'),
        item_list_name: root.getAttribute('data-ccv-list-name'),
        items: [itemOf(card, root)]
      });
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
